module.exports = __webpack_public_path__ + "static/media/face-happy.2bfbc6ac.svg";